<template>
  <div
    class="upload-files-list relative"
    :class="{ _dragover: dragover }"
    @dragenter="dragover = true"
    @dragleave="dragover = false"
    @drop="onDrop"
  >
    <BasePreloader v-if="loading" class="_white" />

    <input
      ref="filesInput"
      v-show="false"
      type="file"
      multiple
      @input="onFilesInput"
    >
    <div
      class="upload-files-list__uploader"
      @click="onUploadClick"
    >
      <div class="upload-files-list__uploader-icon-wrap">
        <BaseSvg name="ico-upload-multiple" width="2.4rem" height="2.4rem" />
      </div>
      <div class="upload-files-list__uploader-title">{{ $tGlobal('upload_files') }}</div>
    </div>

    <div class="upload-files-list__files">
      <div
        v-for="(file, index) in filesList"
        :key="index"
        class="upload-files-list__file relative"
      >
        <BasePreloader
          v-if="(loadWithoutId && !file.id) || loadFilesIdx.includes(file.id)"
          class="_white"
        />

        <div class="upload-files-list__file-icon">
          <BaseSvg name="ico-file-outline" width="1.8rem" height="1.8rem" />
        </div>
        <div class="upload-files-list__file-title">
          {{ file.name }}
        </div>
        <div class="upload-files-list__file-actions">
          <button
            class="base-btn base-btn--x-small upload-files-list__file-action _delete"
            @click="onFileDelete(file)"
          >
            <BaseSvg name="ico-trash" width="1.6rem" height="1.6rem" />
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UploadFilesList',
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    loadWithoutId: {
      type: Boolean,
      default: false,
    },
    loadFilesIdx: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      dragover: false,
      localFiles: [],
    };
  },
  computed: {
    filesList() {
      const reversedLocalFiles = [...this.localFiles].reverse();
      if (this.value) return [...reversedLocalFiles, ...[...this.value].reverse()];
      return reversedLocalFiles;
    },
  },
  mounted() {
    this.$el.addEventListener('dragover',(e) => e.preventDefault(),false);
    this.$el.addEventListener('drop',(e) => e.preventDefault(),false);
  },
  methods: {
    onDrop($event) {
      this.dragover = false;
      const files = $event.dataTransfer.files;
      this.onFilesInput(undefined, files);
    },
    onUploadClick() {
      this.$refs.filesInput.click();
    },
    onFilesInput($event, customFiles) {
      const files = Array.from($event?.target.files || customFiles);
      if (files.length) {
        const onLoadEnd = () => this.localFiles = [];
        this.$emit('upload', files, onLoadEnd);
        this.localFiles = this.localFiles.concat(files);
      }
    },
    onFileDelete(file) {
      this.$emit('delete', file);
    },
  },
};
</script>
